var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "icon-renderer" },
    [_c("icon", { attrs: { "icon-name": _vm.params.value.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }